import React from 'react';

function Hero() {
  return (
    <section id="hero" className="pt-32 pb-32">
      <div className="max-w-[1100px] mx-auto px-8 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-8">
          <p className="text-label-sm text-primary uppercase tracking-[0.2em] mb-6">
            Current Role
          </p>
          <h1 className="text-display-xl text-on-background leading-[1.1] mb-10">
            Engineering Director{' '}
            <span className="text-primary/40">@</span>{' '}
            Etsy
          </h1>
          <p className="text-body-lg text-on-surface-variant max-w-xl">
            Engineering leader with 20 years of experience spanning automation, SRE, DevOps, and
            platform infrastructure across Etsy, Comcast, and Snapchat. I've built and scaled teams
            accountable for mission-critical systems — from CDNs serving 100B+ daily requests to
            release pipelines reaching hundreds of millions of users. Drawn to the intersection of
            technical rigor and organizational clarity, building systems and teams that are
            resilient, efficient, and measurably better over time.
          </p>
        </div>
        <div className="col-span-12 md:col-span-4 flex items-start justify-end pt-4">
          <div className="w-48 h-48 rounded-full overflow-hidden border border-primary/20 p-1">
            <img
              src={require('../assets/images/website_profile_photo.JPG')}
              alt="Nick Bitzer"
              className="w-full h-full object-cover rounded-full grayscale opacity-80"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
